// Analytics configuration

export const ANALYTICS_CONFIG = {
    // Google Tag Manager
    GTM: {
        ID: process.env.GATSBY_GTM_ID || '',
        ENABLED: process.env.GATSBY_ENV === 'prod' && !!process.env.GATSBY_GTM_ID,
        ENVIRONMENT: process.env.GATSBY_ENV || 'development',
    },

    /**
     * postMessage iframe bridge — MetaDefender Cloud → My OPSWAT
     *
     * GATSBY_PARENT_ORIGIN   Parent origin for postMessage (absolute URL, e.g. https://my.opswat.com).
     *                        Set at build time; never use `*`. Missing/invalid → bridge skips postMessage.
     */
    IFRAME: {
        PARENT_ORIGIN: process.env.GATSBY_PARENT_ORIGIN || '',
        /**
         * Identifier stamped on every outbound postMessage so the parent can
         * filter events that originate from this app vs other potential senders.
         */
        EVENT_SOURCE: 'metadefender-cloud' as const,
        /**
         * Envelope schema version.  Increment when the IframeEvent shape changes
         * so the parent can handle both old and new versions during rollouts.
         */
        SCHEMA_VERSION: '1' as const,
    },

    // Feature flags
    FEATURES: {
        TRACK_PAGE_VIEWS: true,
        TRACK_USER_INTERACTIONS: true,
        TRACK_FORM_SUBMISSIONS: true,
        TRACK_FILE_UPLOADS: true,
        TRACK_API_CALLS: true,
        TRACK_ERRORS: true,
        TRACK_PERFORMANCE: true,
    },

    // Event names
    EVENTS: {
        PAGE_VIEW: 'page_view',
        USER_INTERACTION: 'user_interaction',
        FORM_SUBMIT: 'form_submit',
        FILE_UPLOAD: 'file_upload',
        API_CALL: 'api_call',
        ERROR: 'error',
        PERFORMANCE: 'performance',
        ROUTE_CHANGE: 'route-change',
    },

    // Categories for user interactions
    CATEGORIES: {
        NAVIGATION: 'navigation',
        FORM: 'form',
        FILE: 'file',
        API: 'api',
        ERROR: 'error',
        PERFORMANCE: 'performance',
    },

    // Actions for user interactions
    ACTIONS: {
        CLICK: 'click',
        SUBMIT: 'submit',
        UPLOAD: 'upload',
        DOWNLOAD: 'download',
        SEARCH: 'search',
        FILTER: 'filter',
        SORT: 'sort',
        EXPAND: 'expand',
        COLLAPSE: 'collapse',
    },
};

// Check if analytics should be enabled
export const isAnalyticsEnabled = (): boolean => {
    return ANALYTICS_CONFIG.GTM.ENABLED;
};

// Check if we're in production
export const isProduction = (): boolean => {
    return ANALYTICS_CONFIG.GTM.ENVIRONMENT === 'prod';
};

// Check if we're in development
export const isDevelopment = (): boolean => {
    return ANALYTICS_CONFIG.GTM.ENVIRONMENT === 'development';
};

// Get GTM ID safely
export const getGTMID = (): string => {
    return ANALYTICS_CONFIG.GTM.ID;
};

// Check if a specific feature is enabled
export const isFeatureEnabled = (feature: keyof typeof ANALYTICS_CONFIG.FEATURES): boolean => {
    return ANALYTICS_CONFIG.FEATURES[feature] && isAnalyticsEnabled();
};
